import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TicketTransferWindowStatusComponent } from './ticket-transfer-window-status.component';
import { CountdownModule } from '@fgb/portal-component-library/src/lib/shared/countdown';

import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';

@NgModule({
  declarations: [TicketTransferWindowStatusComponent],
  imports: [
    CommonModule,
    CountdownModule,
    FGBSharedModule
  ],
  exports: [TicketTransferWindowStatusComponent],
})
export class TicketTransferWindowStatusModule {}
